import campaignTemplate from './campaignTab.html';

const campaignTab = {
    bindings: {
        onTypeChanged: '&',
        taskStarted: '&',
        taskEnded: '&',
        onSearch: '=',
        campaignType: '=',
        searchText: '=',
    },

    template: campaignTemplate,

    controller: function (
        ApiCampaigns,
        $scope,
        $state,
        MessageBox,
        filterHistory
    ) {
        this.campaigns = [];
        this.motherCampaigns = [];
        this.filterHistory = filterHistory;
        this.motherCampaignLength = 0;

        this.$onInit = () => {
            this.preLoadFilter();
            this.getAllChildCampaigns();
            this.getAllMotherCampaigns();
        };

        this.getAllChildCampaigns = function () {
            this.onTypeChanged({ campaignType: this.campaignType });
            this.taskStarted();
            ApiCampaigns.getAllChildCampaigns().then((campaigns) => {
                this.campaigns = campaigns || [];
                this.taskEnded();
            });
        };

        this.getAllMotherCampaigns = function () {
            this.onTypeChanged({ campaignType: this.campaignType });
            this.taskStarted();
            ApiCampaigns.getAllMotherCampaigns().then((motherCampaigns) => {
                this.motherCampaigns = motherCampaigns || [];
                this.motherCampaignLength =
                    motherCampaigns != null ? motherCampaigns.length : 0;
                this.resetCaretButton();
                this.taskEnded();
            });
        };

        this.removeCampaign = function (campaign, index, type) {
            this.taskStarted();
            ApiCampaigns.deleteCampaign(campaign.campaignId).then(
                (res) => {
                    this.taskEnded();
                    if (res === undefined) return;
                    if ('CAMPAIGN' === type) {
                        this.campaigns.splice(index, 1);
                    } else if ('MOTHER_CAMPAIGN' === type) {
                        this.motherCampaigns.splice(index, 1);
                    }
                    MessageBox.showSuccessMessage('CAMPAIGN', 'DELETE');
                },
                (error) => {
                    this.taskEnded();
                }
            );
        };

        this.preLoadFilter = () => {
            let filter = this.filterHistory.readFilter('campaign');
            if (filter) {
                this.searchText = filter.searchText;
            }
        };

        this.onSearch = (search) => {
            this.searchText = search;
            if (search) {
                this.filterHistory.saveFilter(
                    { searchText: this.searchText },
                    'campaign'
                );
            } else {
                this.filterHistory.removeFilter('campaign');
            }
        };

        this.assignChildrenToMother = function (mother) {
            ApiCampaigns.getCampaignChildren(mother.campaignId).then(
                (children) => {
                    if (!!children) {
                        let indexOfMother =
                            this.motherCampaigns.indexOf(mother) + 1;
                        children.map((c) => {
                            c.isChild = true;
                            c.parent = mother.campaignTitle;
                            this.motherCampaigns.splice(indexOfMother, 0, c);
                        });
                    }
                }
            );
        };

        this.clearChildren = function (mother) {
            let children = this.motherCampaigns.filter((c) => {
                return c.isChild && c.parent === mother.parent;
            });

            children.map((c) => {
                let index = this.motherCampaigns.indexOf(c);
                this.motherCampaigns.splice(index, 1);
            });
        };

        this.resetCaretButton = () => {
            this.motherCampaigns.map((c) => {
                c.parent = c.campaignTitle;
                c.isChild = false;
                c.isExpanded = false;
            });
        };

        this.onMotherItemClick = ($event, campaign) => {
            if (!$event) return;

            $event.preventDefault();

            if ($event.target.className.includes('arrow-picton-blue')) {
                this.arrowButtonClicked(campaign);
            }
        };

        this.arrowButtonClicked = function (campaign) {
            campaign.isExpanded = !campaign.isExpanded;
            if (campaign.isExpanded) {
                this.assignChildrenToMother(campaign);
            } else {
                this.clearChildren(campaign);
            }
        };

        this.getCampaignUrl = (campaignId) => {
            return $state.href('campaignDetail', {
                campaignId: campaignId,
                sortOrder: null,
            });
        }
    },
};

export default campaignTab;



/** WEBPACK FOOTER **
 ** ./src/app/directives/campaignTab/campaignTab.js
 **/